const prometheusAliasReplacePattern = /\./g;
/**
 * We use `.` to separate our namespaces in the PerformanceMarkName and PerformanceMeasureName
 *
 * However, we can't send `.` separated strings as names to Prometheus and instead need `_` separated strings.
 *
 * @param performanceMarkName original performance mark name
 * @returns {string} - transformed performance mark name
 */
export function getPrometheusAlias(performanceMarkName: string): string {
  return performanceMarkName.replace(prometheusAliasReplacePattern, "_");
}
